module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd",
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center",
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-6 order-md-2"
  }, [_c('div', {
    staticClass: "bc-video-player",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('video', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "preload": "metadata",
      "autoplay": "true",
      "muted": "",
      "id": "video",
      "poster": "/static/images/video.jpg",
      "playsinline": "",
      "webkit-playsinline": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "οncanplay": function($event) {
        return _vm.canplay()
      }
    }
  }, [_c('source', {
    attrs: {
      "src": "//cloud.video.alibaba.com/play/u/2153292369/p/1/e/6/t/1/d/hd/317537464684.mp4"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 order-md-1 aos-init aos-animate",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('p', {
    staticClass: "header-text text-md-start",
    staticStyle: {
      "color": "#526193"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('home_title')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333 !important",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('home_desc_1')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333 !important",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('home_desc_2')) + "\n                    ")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "border-radius": "25px",
      "padding": "10px 20px",
      "background": "#526193 !important",
      "border": "1px solid #826e9e"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gotoUrl('aboutus')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_view_detail')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-reverse"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "30px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#526193",
      "font-size": "24px",
      "font-weight": "bold",
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_1')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_1_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_2')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_2_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_3')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_3_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_4')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_4_detail')) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "40px",
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0px",
      "margin-top": "50px",
      "font-size": "24px",
      "color": "#526193",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product')))]), _vm._v(" "), _c('div', {
    staticClass: "all-products"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('114')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1_detail')) + "\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('115')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2_detail')) + "\n\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('57')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3_detail')) + "\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('61')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4_detail')) + "\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-reverse"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "30px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0px",
      "margin-top": "0px",
      "font-size": "24px",
      "color": "#526193",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_adv')))]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_1')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_1_detail')) + "            ")]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_2')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_2_detail')) + "            ")]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_3')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_3_detail')) + "            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-factory.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-production.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-rd.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-delivery.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product57_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product61_logo.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46522594"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 420
// module chunks = 1